/* eslint-disable array-callback-return */
import { BaseSyntheticEvent, FC, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import uuid from 'react-uuid'
import Swal from 'sweetalert2'
import { PageTitle } from '../../../../../_metronic/layout/core'
import { Button } from '../../../../components/Button/Button'
import { Input } from '../../../../components/Input/Input'
import { Loading } from '../../../../components/Loading/Loading'
import { GET, POST, PUT } from '../../../../services/api'
import { i18n } from '../../../../translate/i18n'
import { BreadCrumbs } from '../../../../components/BreadCrumbs/breadCrumbrs'
import { EditorQuill } from '../../../../components/EditorQuill/EditorQuill'

type ReturnType = {
  id: string
  parent: string
  code: string
  name: string
  description: string
  value: string
  select: string
}

const Content: FC = () => {
  const navigate = useNavigate()

  const { id } = useParams()

  const [listClassification, setListClassification] = useState<any[]>([])
  const [loading, setLoading] = useState(false)
  const [categories, setCategories] = useState<any[]>([])
  const [categoryId, setCategoryId] = useState<any>('0')
  const [title, setTitle] = useState<string>('')
  const [order, setOrder] = useState<string>('0')

  const [content, setContent] = useState('')

  const [image, setImage] = useState<File | null>(null)
  const [firstStateImage, setFirstStateImage] = useState<File | null>(null)

  const generateClassificationTree = (
    categories: ReturnType[],
    parent: string | null,
    name: string
  ): any => {
    const parentCategory = categories.find((category) => category.code === parent)
    if (parentCategory)
      return `${generateClassificationTree(
        categories,
        parentCategory.parent,
        parentCategory.name
      )} > ${name}`
    else return name
  }

  const getCategories = async () => {
    setLoading(true)
    try {
      const res = await GET(`/classification-posts`)
      res.data.map((row: ReturnType) => {
        listClassification.push({
          id: row.id,
          parent: row.parent,
          code: row.code,
          name: row.name,
        })
      })
      const categories = [
        {
          value: 0,
          select: 'Selecione',
          key: -1,
        },
      ]
      listClassification.map((row: any, idx) => {
        categories.push({
          value: row.id,
          select: row.name,
          key: idx,
        })
      })
      setCategories(categories)
      setLoading(false)
    } catch (e) {
      setLoading(false)
      console.log(e)
    }
  }

  useEffect(() => {
    getCategories()
  }, [])

  function validateForm(){
    if(!title){
      Swal.fire({
        icon: 'error',
          title: String(i18n.t(`hospitality_post.form_validate.fields_missing`)),
        text: String(i18n.t(`hospitality_post.form_validate.title_required`)),
      })
      return false
    }

    if(!categoryId ||categoryId === '0'){
      Swal.fire({
        icon: 'error',
        title: String(i18n.t(`hospitality_post.form_validate.fields_missing`)),
        text: String(i18n.t(`hospitality_post.form_validate.classification_required`)),
      })
      return false
    }

    if(!content){
      Swal.fire({
        icon: 'error',
        title: String(i18n.t(`hospitality_post.form_validate.fields_missing`)),
        text: String(i18n.t(`hospitality_post.form_validate.content_required`)),
      })
      return false
    }

    return true

  }

  const create = async () => {
    const categorySelected: any = categoryId
    setLoading(true)
    try {
      if (!title) {
        Swal.fire({
          icon: 'error',
          title: 'Campos faltantes',
          text: 'Verifique se preencheu todos os campos!',
        })
      } else {
        
        let imageRes = {
          success: false,
          image: '',
        }
        const res = await POST('/post', {
          classificationId: categorySelected.value,
          title,
          content,
          order: order ?? 0,
          status: true,
          img: imageRes.success ? imageRes.image : 'default/no-image.png',
        })
        if (image) {
          const formData = new FormData()
          formData.append('file', image)
          formData.append('nameImage', `post-${uuid()}.jpg`)
          formData.append('originalSize', 'true')
          imageRes = await POST('/upload-images/upload-one', formData)
          if (imageRes.success) {
            await PUT(`/post/${res.data.id}`, {
              img: imageRes.image,
            })
          }
        }

        
        if (res.success === true) {
          Swal.fire({
            icon: 'success',
            title: String(i18n.t(`hospitality_post.create.success.created_title`)),
            text: String(i18n.t(`hospitality_post.create.success.created_text`)),
          }).then(() => navigate('/hospitality/posts'))
        } else {
          Swal.fire({
            icon: 'error',
            title: String(i18n.t(`hospitality_post.create.error.created_title`)),
            text: String(i18n.t(`hospitality_post.create.error.created_text`)),
          })
        }
      }
    } catch (e: any) {
      
      console.log(e)
      Swal.fire({
        icon: 'error',
        title: String(i18n.t(`hospitality_post.create.error.created_title`)),
        text: String(i18n.t(`hospitality_post.create.error.created_text`)),
      })
    } finally{
      setLoading(false)
    }
  }

  if (loading) {
    <Loading />
  }

  return (
    <>
      <div className='row g-5 gx-xxl-12'>
        <div className='card card-xxl-stretch mb-5 mb-xl-12'>
          <div className='card-header py-5'>
            <h3 className='card-title align-items-start flex-column'>
              <span className='card-label fw-bolder fs-3 mb-1'>{i18n.t(`hospitality_post.create.page_title`)}</span>
              <BreadCrumbs />
              <span className='text-muted mt-1 fw-bold fs-7'>
                {i18n.t(`hospitality_post.create.page_subtitle`)}
              </span>
            </h3>
          </div>
          <div className='card-body '>
            <div className='row'>
              <div className='col-lg-10'>
                <div className='row'>
                  <div className='col-lg-4' style={{ zIndex: 4 }}>
                    <Input
                      inputAttr={{
                        type: 'select',
                      }}
                      search
                      label={i18n.t(`smart_order.category`)}
                      options={categories}
                      value={categoryId}
                      change={(value: string) => {
                        setCategoryId(value)
                        console.log(categoryId)
                      }}
                    />
                  </div>
                  <div className='col-lg-12'>
                    <Input
                      inputAttr={{
                        type: 'default',
                      }}
                      placeholder={i18n.t(`feed.title`)}
                      label={i18n.t(`feed.title`)}
                      value={title}
                      change={(value: string) => setTitle(value)}
                    />
                  </div>
                </div>
              </div>
              <div className='col-lg-2'>
                <Input
                  inputAttr={{
                    type: 'image',
                  }}
                  label={i18n.t(`smart_order.image`)}
                  value={image}
                  change={(value: BaseSyntheticEvent) =>
                    setImage(value ? value.target.files[0] : null)
                  }
                />
              </div>
            </div>
            <div className='row'>
              <div className='col-lg-12'>
                <div className='d-flex justify-content-between align-items-end mt-4 flex-wrap gap-5'>
                  <div className='w-100'>
                    <div className='mt-6'>
                      <label className='form-label fw-normal'>{i18n.t(`feed.content`)}</label>
                      <EditorQuill
                        value={content}
                        change={(value: string) => setContent(value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='d-flex w-100'>
            <div className='col-6 d-flex justify-content-start'>
              <Button
                text={i18n.t(`buttons.back`)}
                color='info'
                size='small'
                horizontalPadding={6}
                btnAttr={{
                  type: 'button',
                }}
                click={() => navigate(-1)}
                btnClass='fw-bolder m-9'
              />
            </div>
            <div className='col-6  d-flex justify-content-end'>
              <Button
                text={i18n.t(`buttons.save`)}
                color='primary'
                size='small'
                horizontalPadding={6}
                btnAttr={{
                  type: 'button',
                }}
                click={() => {
                  create()
                }}
                btnClass='fw-bolder m-9'
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const PostCriar: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          { title: 'Dashboard', path: 'dashboard', isActive: true },
          { title: i18n.t(`hospitality_post.index.page_title`), path: 'hospitality/posts', isActive: true },
          {
            title: i18n.t(`hospitality_post.create.page_title`),
            path: 'hospitality/posts/criar',
            isActive: true,
          },
        ]}
      >
        {i18n.t(`hospitality_post.create.page_title`)}
      </PageTitle>
      <Content />
    </>
  )
}

export { PostCriar }
